import { NextPage } from 'next';
import React from 'react';
import dynamic from 'next/dynamic'
import { FormattedMsg, FormattedMsgWithDOM } from '@components/i18n/formattedMsg';
import LoginBanner from '@components/user/LoginBanner';

const AmplifyAuthenticator = dynamic(
  () => import('@components/user/AmplifyAuthenticator'),
  { ssr: false }
)


const LoginPage: NextPage = () => {

  return (
    <>
      <LoginBanner
        title={<FormattedMsgWithDOM id={"login.title"} />}
        content={<FormattedMsg id={"login.content"} />}
        form={<AmplifyAuthenticator />}
      />
    </>)
};

export default (LoginPage);